<template>
  <div class="remove-all-input-styling">
    <label class="text-sm at-choose-client remove-outline">Expense Code</label>
    <v-autocomplete
      ref="expenseRef"
      data-cy="expense-code-dropdown"
      v-model="selectedCode"
      :items="expenseState.expenseCodes"
      :loading="expenseState.loading"
      item-title="label"
      item-value="id"
      return-object
      clearable
      density="compact"
      variant="outlined"
      class="remove-outline"
      placeholder="Expense Code"
      hide-details="true"
      :item-props="(item) => ({ disabled: item.disabled })"
      :menu-props="{ maxWidth: expenseRef?.$el?.offsetWidth }"
      :disabled="disabled"
      v-on:update:model-value="handleCodeChange"
    ></v-autocomplete>
  </div>
</template>
<script setup lang="ts">
import { onMounted, reactive, ref, watch } from 'vue';
import { useCodeStore } from '@/services/useCodeStore';

const codeStore = useCodeStore();
const emit = defineEmits(['update:modelValue', 'codeChange']);

const props = defineProps({
  modelValue: {
    type: Object,
    required: false,
    default: () => ({ id: '', label: '' }),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const expenseRef = ref(null);
const selectedCode = ref(props.modelValue);

const expenseState = reactive({
  loading: false,
  expenseCodes: [],
});

onMounted(async () => {
  try {
    expenseState.loading = true;
    expenseState.expenseCodes = await codeStore.expenseCodes();
    populateSelected();
  } catch (error) {
    console.error(error);
  } finally {
    expenseState.loading = false;
  }
});

const populateSelected = () => {
  if (props.modelValue?.id) {
    selectedCode.value =
      expenseState.expenseCodes.find((e) => e.id === props.modelValue.id) ||
      props.modelValue;
  } else {
    selectedCode.value = { id: '', label: '' };
  }
};

const handleCodeChange = (value) => {
  selectedCode.value = value;
  emit('update:modelValue', value);
  emit('codeChange', value);
};

watch(
  () => props.modelValue,
  () => {
    populateSelected();
  },
);
</script>
<style scoped>
:deep(.v-autocomplete .v-autocomplete__selection-text) {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
</style>
